<template>
  <HomeLayout>
    <b-row class="column-border-container">
      <b-col class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click.prevent="openSubmitQuery">
          <div class="navigation-block">
            <h4 class="nav-title-center">CONTACT US</h4>
            <div class="nav-text-center">
              <i class="icon-email_share vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col v-if="currentEtrails && currentEtrails.length" class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake"  @click.prevent="openCurrentCommunications">
          <div class="navigation-block" style="position: relative;">
            <h4 class="nav-title-center">CURRENT COMMUNICATIONS</h4>
            <div class="nav-text-center">
              <span style="position: relative; display: inline-flex; align-items: center; justify-content: center;">
                <i class="icon-message vtd-icon-7" />
                <span
                  v-if="hasUnreadCurrentEtrails"
                  style="position: absolute; top: 0; right: -8px; width: 12px; height: 12px; background: #e53e3e; border-radius: 50%; display: block;"
                  title="Unread messages"
                />
              </span>
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>

      <b-col v-if="completedEtrails && completedEtrails.length" class="column-border col-lg card-col col-12">
        <div class="vtd-card vtd-animate-shake" @click.prevent="openAllCommunications">
          <div class="navigation-block">
            <h4 class="nav-title-center">ALL COMMUNICATIONS</h4>
            <div class="nav-text-center">
              <i class="icon-email_share vtd-icon-7" />
            </div>
          </div>
          <div class="vtd-card-footer nav-text-center d-none d-lg-block">
            <p class="vtd-home-btn text-center">View Now</p>
          </div>
        </div>
      </b-col>
    </b-row>

    <UrgencyPicker
      ref="UrgencyPickerRef"
      @selected="onUrgencySelected"
    />
    <Etrail
        ref="EtrailRef"
        :booking="booking"
        :contact-mode="contactMode"
        source="urgAssistance"
      />
      <LoginToken
        ref="CommunicationsLoginTokenRef"
        require-submitter
        modal-text="This booking has more than one passenger, so before you can view communications we need to confirm who you are. Please select your name from the list below, and the preferred contact details to reach you on. We'll send you a One Time Passcode to confirm."
        submitter-label="Your Name"
        @passSetPassenger="onCommunicationsPassengerSelected"
      />
      <PostTravelSurvey
      v-if="booking"
      ref="PostTravelSurveyRef"
      :booking="booking"
    />
    <Contact
      v-if="booking"
      ref="ContactRef"
    />
    <Feedback
      v-if="booking && booking.user_information"
      ref="FeedbackRef"
      :email="booking.user_information.email"
    />
      <CurrentCommunications 
        ref="CurrentCommunicationsRef"
      />
      <AllCommunications 
        ref="AllCommunicationsRef"
      />
  </HomeLayout>
</template>

<script>
import HomeLayout from "@/partials/home-layout";
import { mapGetters } from "vuex";
import UrgencyPicker from "@/partials/contact-us/urgency-picker/index.vue";
import Etrail from "@/partials/contact-us/etrail/index.vue";
import PostTravelSurvey from "@/partials/contact-us/post-travel-survey/index.vue";
import Contact from "@/partials/contact-us/contact/index.vue";
import Feedback from "@/modules/booking/feedback";
import CurrentCommunications from '../modals/current-communications/index.vue'
import AllCommunications from '../modals/all-communications/index.vue'
import LoginToken from "@/modules/auth/login-token";
import dayjs from 'dayjs'
import { getTrustPilotURL } from "@/modules/booking/services.js"
import {
  isUrgentCheck,
  isHomeCheck,
} from "@/partials/contact-us/contact-us.module.js";
import { COMMUNICATIONS_PRIVACY_ENABLED } from "@/lib/feature-flags";
export default {
  components: {
    HomeLayout,
    UrgencyPicker,
    Etrail,
    PostTravelSurvey,
    Contact,
    Feedback,
    CurrentCommunications,
     AllCommunications,
    LoginToken
  },
  data() {
    return {
      showOnTheGround: false,
      loginRes: {},
      recentReturn: false,
      feedback: false,
      contactMode: 'pre-travel',
      pendingCommunicationsPassenger: null,
    };
  },
  computed: {
    ...mapGetters({
      booking: "booking/getBooking",
      currentEtrails: "communications/getCurrentEtrails",
      completedEtrails: "communications/getCompletedEtrails",
      verifiedPassengerId: "communications/getVerifiedPassengerId",
      tripHasEnded: "booking/getTripEnded",
      paxNames: "booking/getBookingPassengers",
      departureDate: "booking/getDeptDate",
      fil: "booking/getFil",
    }),
    isUrgent() {
      if (this.booking) {
        return isUrgentCheck(this.booking, this.departureDate);
      }
      return null;
    },
    hasUnreadCurrentEtrails() {
      return (this.currentEtrails || []).some((etrail) =>
        (etrail.messages || []).some((msg) => !msg.client && !msg.read)
      )
    },
    hasMultiplePassengers() {
      return !!(this.paxNames && this.paxNames.length > 1);
    },
    requiresCommunicationsVerification() {
      return (
        COMMUNICATIONS_PRIVACY_ENABLED &&
        this.hasMultiplePassengers &&
        !this.verifiedPassengerId
      );
    },
  },
  created() {
    this.isRecentReturn()
  },
  updated() {
    if (
      (this.fil === "P" && this.booking.feedback_exists !== true) ||
      (this.booking && this.booking.numDaysSinceAuth <= 10 &&
        this.booking.feedback_exists !== true)
    ) {
      this.feedback = true;
    }
  },
  methods: {
    openSubmitQuery() {
      if (this.isUrgent) {
        return this.openUrgencyPicker()
      }
      // No `this.feedback` check here (unlike this used to) — that flag
      // flips on as a side effect of the `updated()` hook re-running after
      // ANY re-render (e.g. right after submitting a query), not because
      // of anything to do with this click. Intercepting "Submit a Query"
      // with the Trustpilot feedback modal meant a second query from this
      // page landed on the wrong screen. The home page's own "Contact Us"
      // shortcut never had this check, which is why only that path worked
      // reliably — feedback is still prompted independently from home's
      // own dedicated banner.
      if (this.recentReturn) {
        return this.openPostTravel()
      }
      // Once the trip has ended and it's past the recent-return window
      // above, there's no query form at all any more - just contact
      // details, matching home/index.vue's isHomeCheckMethod (ContactRef)
      // and viewtrail-expo-v3's equivalent hasReturned branch.
      if (this.tripHasEnded) {
        return this.openContact()
      }
      return this.openEtrail()
    },
    openUrgencyPicker() {
      this.$refs["UrgencyPickerRef"].show();
    },
    openEtrail() {
      this.$refs['EtrailRef'].show()
    },
    openPostTravel() {
      this.$refs['PostTravelSurveyRef'].show();
    },
    openContact() {
      this.$refs['ContactRef'].show();
    },
    openCurrentCommunications() {
      this.checkCommunicationsAccess(() => {
        this.$refs['CurrentCommunicationsRef'].showModal()
      })
    },
    openAllCommunications() {
      this.checkCommunicationsAccess(() => {
        this.$refs['AllCommunicationsRef'].showModal()
      })
    },
    // Only Current/All Communications are gated - Submit a Query is left
    // alone, since submitting already requires picking who it's from.
    // Always forces a fresh submitter-select + OTP confirm (never reuses
    // an existing auth token from Profile/etc - see LoginToken's
    // authCheckCommunications), remembered for the rest of the session via
    // communications/verifiedPassengerId (cleared on logout).
    checkCommunicationsAccess(callback) {
      if (!this.requiresCommunicationsVerification) {
        callback()
        return
      }
      this.pendingCommunicationsPassenger = null
      this.$refs['CommunicationsLoginTokenRef'].authCheckCommunications(() => {
        if (this.pendingCommunicationsPassenger) {
          this.$store.dispatch(
            'communications/setVerifiedPassengerIdAction',
            this.pendingCommunicationsPassenger.id,
          )
        }
        callback()
      })
    },
    onCommunicationsPassengerSelected(passenger) {
      this.pendingCommunicationsPassenger = passenger
    },
    async openFeedbackModal() {
      const tpurl = await getTrustPilotURL(this.booking.user_information.bookingNumber, this.paxNames[0])
      if(tpurl) this.$refs.FeedbackRef.showModal(tpurl);
    },
     onUrgencySelected(mode) {
      this.contactMode = mode;
      this.$refs["EtrailRef"].show();
    },
    isRecentReturn() {
      // if the return date is within a 28-day window from today
      if (this.tripHasEnded) {
        const now = dayjs(new Date());
        const twentyEightDaysAgo = now.subtract(28, "days");
        const returnDate = dayjs(
          this.booking.booking_information.vtdate_return
        );
        if (returnDate.isAfter(twentyEightDaysAgo)) this.recentReturn = true;
      } else {
        this.recentReturn = false;
      }
    },
  }
};
</script>